// Framework and third-party non-ui
import React from 'react';

// Third-party components (buttons, icons, etc.)
import { makeStyles } from '@material-ui/core/styles';

import Deselect from './Deselect';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex'
    },
    optionButton: {
        marginRight: theme.spacing(1),
        backgroundColor: '#ffffff',
        borderRadius: '5px',
        height: '45px',
        width: '120px',
        color: '#4D4D4D',
        letterSpacing: '2px',
        '&:hover': {
          background: "#e6e6e6",
       },
       whiteSpace: 'nowrap'
    },
  }
));

const TrailOptions = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
        <Deselect />
    </div>
  );
};

export default TrailOptions;